import moment from "moment-timezone";
import { getAuth, signInWithCustomToken, signOut } from "firebase/auth";
import { getApiFunctions } from "store/user/api";
import { getApp } from "firebase/app";
import { PROJECT_ID } from "config/keys/user";

const app = getApp();
const auth = getAuth(app);
//
const appUser = getApp(PROJECT_ID);
const authUser = getAuth(appUser);

// tạo auth mới.
export const silentLogin = (callback) => async (dispatch) => {
  // 1. get token
  const token = await getTokenFromUser(callback);
  console.log({ token });

  if (!token) {
    callback && callback({ status: 500, data: "Token is Invalids" });
    return;
  }

  console.log({ token });

  // 2. login with token
  return loginWithToken({ token, callback });
};

const getTokenFromUser = async (callback) => {
  const functions = getApiFunctions().generateToken;
  const options = {};
  return functions(options)
    .then((res) => {
      const data = res?.data?.data;
      console.log({ res });
      callback && callback({ status: 200 });
      return data;
    })
    .catch((err) => {
      console.log({ err });

      return null;
    });
};

const loginWithToken = async ({ token, callback }) => {
  console.log({ auth });
  return signInWithCustomToken(auth, token)
    .then(() => {
      const current = moment().toISOString();
      console.log({ userAppear: current });
      callback && callback({ status: 200 });
    })
    .catch((err) => {
      console.log({ err });
      callback &&
        callback({ status: 500, data: err?.message || "Please try again!" });
    });
};

// silient logout.
export const silentLogout = (callback) => async (dispatch) => {
  const pBailiff = signOut(auth);
  const pUser = signOut(authUser);
  Promise.all([pBailiff, pUser])
    .then(() => {
      callback && callback({ status: 200 });
    })
    .catch((err) => {
      console.log({ err });
      callback &&
        callback({ status: 500, data: err?.message || "Please try again!" });
    });
};
